/**
 * WBS／群組階層的展開收合輔助（純函式）。與 grid/visibility.ts 邏輯相同,
 * 但因檔案所有權切分而在此獨立實作一份極簡版本,供 resource/cost 視圖共用。
 */

export interface HierarchyNode {
  readonly id: string;
  readonly parentId: string | null;
}

/** 依 collapsedIds 過濾出應顯示的節點（祖先被收合者，自身也不顯示）。 */
export function getVisibleNodes<T extends HierarchyNode>(
  nodes: readonly T[],
  collapsedIds: readonly string[],
): readonly T[] {
  const collapsedSet = new Set(collapsedIds);
  const byId = new Map(nodes.map((n) => [n.id, n]));

  const isHidden = (node: T): boolean => {
    let current: T | undefined = node;
    while (current && current.parentId !== null) {
      const parent = byId.get(current.parentId);
      if (parent === undefined) break;
      if (collapsedSet.has(parent.id)) return true;
      current = parent;
    }
    return false;
  };

  return nodes.filter((node) => !isHidden(node));
}
